import { isAxiosError } from 'axios'

// WHY: responseType:'blob' だと BE エラーも response.data が Blob で届き interceptor が正規化しないため、Blob を text 化して envelope の message/detail を復元する
export const parseBlobErrorMessage = async (error: unknown): Promise<string | null> => {
  if (!isAxiosError(error)) return null
  const data = error.response?.data
  if (!(data instanceof Blob)) return null

  const text = await data.text().catch(() => '')
  if (!text) return null

  try {
    const parsed = JSON.parse(text) as { message?: unknown; detail?: unknown }
    const message = parsed.message ?? parsed.detail
    return typeof message === 'string' && message ? message : null
  } catch {
    // JSON でない（HTML エラーページ等）はそのまま表示しても読めないので握る
    return null
  }
}
